import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { SchedulingOrderFOBActions } from "store/ducks/ordersFob";

export function* schedulingOrderFOBRequest(action: any) {
  try {
    const { putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/orders-fob-scheduled`,
      putData
    );

    const { data } = responseBody;
    yield put(SchedulingOrderFOBActions.success(data));
    notify("success", "Agendamento criado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(SchedulingOrderFOBActions.failure(errorMessage));
  }
}
